// Invitaciones (activación de cuenta) sobre TanStack Query. Rutas públicas:
// no dependen de la sesión de `useAuth`.

import { useMutation, useQuery } from "@tanstack/react-query";

import {
  aceptarInvitacionRequest,
  validarInvitacion,
  type AceptarInvitacionInput,
} from "@/lib/invitaciones";

export function useValidarInvitacion(token: string | null, email: string | null) {
  return useQuery({
    queryKey: ["invitacion", token, email] as const,
    queryFn: () => validarInvitacion(token!, email!),
    enabled: Boolean(token && email),
    retry: false, // 404/410 son estados válidos del enlace, no fallos a reintentar.
  });
}

export function useAceptarInvitacion() {
  return useMutation({
    mutationFn: (input: AceptarInvitacionInput) => aceptarInvitacionRequest(input),
  });
}
